import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import ShellLayout from './layouts/ShellLayout';
import HolisticView from './views/holistic/HolisticView';
import OpsSliver from './views/ops/OpsSliver';
import OpsBranchView from './views/ops/OpsBranchView';
import HRSliver from './views/hr/HRSliver';
import HRBranchView from './views/hr/HRBranchView';
import FinanceSliver from './views/finance/FinanceSliver';
import FinanceBranchView from './views/finance/FinanceBranchView';
import ISOSliver from './views/iso/ISOSliver';
import ISOBranchView from './views/iso/ISOBranchView';
import ComplianceSliver from './views/compliance/ComplianceSliver';
import ComplianceBranchView from './views/compliance/ComplianceBranchView';
import SupplySliver from './views/supply/SupplySliver';
import SupplyBranchView from './views/supply/SupplyBranchView';
import SalesSliver from './views/sales/SalesSliver';
import SalesBranchView from './views/sales/SalesBranchView';
import MeasurabilitySliver from './views/measurability/MeasurabilitySliver';
import MeasurabilityBranchView from './views/measurability/MeasurabilityBranchView';
import HolisticBranchView from './views/holistic/HolisticBranchView';
import './App.css';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<ShellLayout />}>
          <Route index element={<Navigate to="/sliver/holistic" replace />} />
          <Route path="sliver/holistic" element={<HolisticView />} />
          <Route path="sliver/holistic/branch/:branchId" element={<HolisticBranchView />} />
          <Route path="sliver/ops" element={<OpsSliver />} />
          <Route path="sliver/ops/branch/:branchId" element={<OpsBranchView />} />
          <Route path="sliver/hr" element={<HRSliver />} />
          <Route path="sliver/hr/branch/:branchId" element={<HRBranchView />} />
          <Route path="sliver/finance" element={<FinanceSliver />} />
          <Route path="sliver/finance/branch/:branchId" element={<FinanceBranchView />} />
          <Route path="sliver/iso" element={<ISOSliver />} />
          <Route path="sliver/iso/branch/:branchId" element={<ISOBranchView />} />
          <Route path="sliver/compliance" element={<ComplianceSliver />} />
          <Route path="sliver/compliance/branch/:branchId" element={<ComplianceBranchView />} />
          <Route path="sliver/supply" element={<SupplySliver />} />
          <Route path="sliver/supply/branch/:branchId" element={<SupplyBranchView />} />
          <Route path="sliver/sales" element={<SalesSliver />} />
          <Route path="sliver/sales/branch/:branchId" element={<SalesBranchView />} />
          <Route path="sliver/measurability" element={<MeasurabilitySliver />} />
          <Route path="sliver/measurability/branch/:branchId" element={<MeasurabilityBranchView />} />
          <Route path="*" element={<Navigate to="/sliver/holistic" replace />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}

export default App;
